"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyAddProjectV1ProjectsAddPostSourceType = void 0;
exports.BodyAddProjectV1ProjectsAddPostSourceType = {
    Blank: "blank",
    Book: "book",
    Article: "article",
    Genfm: "genfm",
    Video: "video",
};
